import styled, {css} from 'styled-components'

const commonStyles = css`
  aspect-ratio: 16 / 9;
  border-radius: 8px;
  margin-top: 16px;
  margin-bottom: 16px;
`

export const Video = styled.video`
  object-fit: cover;
  ${commonStyles}
`

export const Iframe = styled.iframe`
  ${commonStyles}
`
